import { IonIcon } from '@ionic/react'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { callOutline } from 'ionicons/icons'
import type { TeamAssignment } from '../../helpers/teamAssignments'

/** v1 hides the role label for the crew's default roles */
const UNLABELED_ROLE_SLUGS = ['lead', 'support']

/** Team section: members with role + call link (not for self). */
export const TeamList = ({
  teamAssignments,
  currentOperatorId,
}: {
  teamAssignments: TeamAssignment[]
  currentOperatorId: number | null | undefined
}) => {
  const { _ } = useLingui()
  if (teamAssignments.length === 0) return null

  return (
    <div className='assignment-detail__hero-block'>
      <div className='assignment-detail__section-title'>{_(msg`Team`)}</div>
      <ul className='assignment-detail__team-list'>
        {teamAssignments.map((ta) => {
          const op = ta.operator
          const fullName = [op.firstName, op.lastName].filter(Boolean).join(' ')
          const isRoleLabelHidden = UNLABELED_ROLE_SLUGS.includes(
            ta.roleDetails.slug,
          )
          const role = isRoleLabelHidden ? null : ta.roleDetails.name
          const phone = op.phones?.[0]?.number
          const isSelf = op.id === currentOperatorId

          return (
            <li key={ta.id} className='assignment-detail__team-member'>
              <div className='assignment-detail__team-info'>
                <span className='assignment-detail__team-name'>{fullName}</span>
                {role && (
                  <span className='assignment-detail__team-role'>{role}</span>
                )}
              </div>
              {!isSelf && phone && (
                <a
                  href={`tel:${phone}`}
                  className='assignment-detail__team-phone'
                  aria-label={_(msg`Call ${fullName}`)}
                >
                  <IonIcon icon={callOutline} />
                </a>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
